module.exports = __webpack_public_path__ + "img/2.8b72993a.jpg";